// SVG Icon for sample button
const svgIcon = `<svg width="30" height="32" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.4792 4.88809C18.2328 4.57809 17.9298 4.32311 17.588 4.13825C17.2462 3.95339 16.8725 3.84239 16.4892 3.81184L7.68916 2.51246C7.31357 2.43095 6.9262 2.42961 6.55011 2.50853C6.17402 2.58745 5.81689 2.74501 5.49999 2.97184C5.20453 3.23 4.96143 3.54781 4.78508 3.90642C4.60872 4.26504 4.50271 4.65717 4.47332 5.05959L4.35082 5.96696H3.88916C3.50441 5.92004 3.11455 5.9651 2.74873 6.09876C2.38292 6.23242 2.05064 6.45123 1.77675 6.73881C1.50287 7.02639 1.29448 7.37529 1.16718 7.75939C1.03988 8.14349 0.996969 8.55286 1.04166 8.95684V16.5413C0.996969 16.9453 1.03988 17.3547 1.16718 17.7388C1.29448 18.1229 1.50287 18.4718 1.77675 18.7594C2.05064 19.0469 2.38292 19.2657 2.74873 19.3994C3.11455 19.5331 3.50441 19.5781 3.88916 19.5312H12.7792C14.37 19.5312 15.3392 18.7315 15.5708 17.265C16.1969 17.2216 16.7848 16.9339 17.219 16.4583C17.6531 15.9827 17.902 15.3537 17.9167 14.6951L18.9167 7.18759C18.9946 6.79309 18.996 6.38615 18.9209 5.99107C18.8457 5.59598 18.6955 5.22086 18.4792 4.88809ZM14.3775 16.5413C14.3775 17.7331 13.9142 18.2187 12.7792 18.2187H3.88916C2.75499 18.2187 2.29166 17.7331 2.29166 16.5413V8.95684C2.29166 7.76509 2.75499 7.27946 3.88916 7.27946H12.7792C13.9142 7.27946 14.3775 7.76509 14.3775 8.95684V16.5413ZM17.675 7.00384L16.675 14.5096C16.5533 15.3907 16.2383 15.8343 15.6267 15.9428V8.95684C15.6714 8.55277 15.6284 8.14333 15.5011 7.75915C15.3738 7.37497 15.1653 7.02602 14.8913 6.73843C14.6173 6.45083 14.2849 6.23205 13.919 6.09845C13.5531 5.96484 13.1631 5.91989 12.7783 5.96696H5.61166L5.70999 5.24421C5.73034 4.7774 5.92422 4.33758 6.24999 4.01921C6.6296 3.77974 7.08373 3.70682 7.51416 3.81621L16.315 5.11121C16.7593 5.13308 17.1779 5.33621 17.4817 5.67734C17.7092 6.07612 17.7786 6.55187 17.675 7.00384ZM11.0417 12.75C11.0417 12.924 10.9758 13.0909 10.8586 13.214C10.7414 13.3371 10.5824 13.4062 10.4167 13.4062H8.95832V14.9375C8.95832 15.1115 8.89248 15.2784 8.77527 15.4015C8.65805 15.5246 8.49908 15.5937 8.33332 15.5937C8.16756 15.5937 8.00859 15.5246 7.89138 15.4015C7.77417 15.2784 7.70832 15.1115 7.70832 14.9375V13.4062H6.24999C6.08423 13.4062 5.92526 13.3371 5.80805 13.214C5.69084 13.0909 5.62499 12.924 5.62499 12.75C5.62499 12.5759 5.69084 12.409 5.80805 12.2859C5.92526 12.1629 6.08423 12.0937 6.24999 12.0937H7.70832V10.5625C7.70832 10.3884 7.77417 10.2215 7.89138 10.0984C8.00859 9.97535 8.16756 9.90621 8.33332 9.90621C8.49908 9.90621 8.65805 9.97535 8.77527 10.0984C8.89248 10.2215 8.95832 10.3884 8.95832 10.5625V12.0937H10.4167C10.5824 12.0937 10.7414 12.1629 10.8586 12.2859C10.9758 12.409 11.0417 12.5759 11.0417 12.75Z" fill="#383838"/></svg>`;
// Create a BroadcastChannel
const cartChannel = new BroadcastChannel('cart_channel_collection');

function getMaxSamples() {
  const fromThemeSetting = Number.parseInt(window.sampleMax, 10);
  return Number.isFinite(fromThemeSetting) && fromThemeSetting > 0 ? fromThemeSetting : 5;
}

function isSampleLineItem(item) {
  return Boolean(item?.handle && item.handle.endsWith('-s'));
}

function isLimitExemptLineItem(item) {
  const exemptProp = item?.properties?._sample_limit_exempt;
  return exemptProp === true || exemptProp === 'true';
}

function isCheckerboardSampleLineItem(item) {
  return item?.properties?._sample_style === 'checkerboard';
}

function countsTowardSampleLimit(item) {
  return isSampleLineItem(item) && !isLimitExemptLineItem(item) && !isCheckerboardSampleLineItem(item);
}

function getSampleButtonOptions(button) {
  const container = button?.closest('.grid-icon-content');
  const sampleStyle = button?.getAttribute('data-sample-style') || 'default';
  const checkerboardGroup = button?.getAttribute('data-checkerboard-group') || '';
  const limitExempt =
    (button?.getAttribute('data-sample-limit-exempt') === 'true') ||
    (container?.getAttribute('data-sample-limit-exempt') === 'true');

  return {
    limitExempt,
    sampleStyle,
    checkerboardGroup
  };
}

// Function to update cart data across all tabs
function updateCartData(cartData) {
  localStorage.setItem('cartData', JSON.stringify(cartData));
  cartChannel.postMessage(cartData);
}

// Function to handle cart updates from other tabs
cartChannel.onmessage = (event) => {
  const cartData = event.data;
  localStorage.setItem('cartData', JSON.stringify(cartData));
  refreshButtonStatus(cartData);  // Update the UI as needed
};

// Function to handle mobile tap events
function handleMobileTap(button, event) {
  event.preventDefault();
  event.stopPropagation();

  // Check if button is disabled
  if (button.getAttribute('data-disabled') === 'true') {
    return;
  }

  // Only handle expand/tap behavior for icon buttons
  if (!button.hasAttribute('data-sample-icon')) {
    const container = button.closest('.grid-icon-content');
    const sampleProductId = container.getAttribute('data-sample-product-id');
    if (sampleProductId) {
      addSampleItem(parseInt(sampleProductId, 10), 1, getSampleButtonOptions(button));
    }
    return;
  }

  // For icon buttons, handle the two-tap behavior
  if (!button.hasAttribute('data-expanded')) {
    button.setAttribute('data-expanded', 'true');
    return;
  }

  // If button is already expanded, add to cart
  const sampleProductId = button.closest('.grid-icon-content').getAttribute('data-sample-product-id');
  if (sampleProductId) {
    addSampleItem(parseInt(sampleProductId, 10), 1, getSampleButtonOptions(button));
  }
}

// Function to refresh button status
function refreshButtonStatus(cart) {
  const maxSamples = getMaxSamples();
  const uniqueSamples = new Set();
  cart.items.forEach((item) => {
    if (countsTowardSampleLimit(item)) {
      uniqueSamples.add(item.variant_id);
    }
  });

  document.querySelectorAll('.grid-icon-content').forEach(productElement => {
    const sampleButton = productElement.querySelector('.sample-button');
    if (!sampleButton) {
      return;
    }

    // Reset expanded state when refreshing status
    sampleButton.removeAttribute('data-expanded');

    const sampleProductId = parseInt(productElement.getAttribute('data-sample-product-id'), 10);
    const isIconButton = sampleButton.hasAttribute('data-sample-icon');

    if (uniqueSamples.has(sampleProductId)) {
      if (isIconButton) {
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.setAttribute('data-added', 'true');
        const buttonText = sampleButton.querySelector('.button-text');
        if (buttonText) {
          buttonText.textContent = 'Sample Added';
        }
        const icon = sampleButton.querySelector('svg');
        if (icon) {
          icon.outerHTML = svgIcon;
        }
      } else {
        sampleButton.style.backgroundColor = '#B9BABC';
        sampleButton.style.border = '1px solid #B9BABC';
        sampleButton.style.color = "#FFFFFF";
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.innerHTML = 'Sample Added ' + svgIcon;
      }
    } else if (uniqueSamples.size >= maxSamples) {
      if (isIconButton) {
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.setAttribute('data-limit-reached', 'true');
        const buttonText = sampleButton.querySelector('.button-text');
        if (buttonText) {
          buttonText.textContent = 'Limit Reached';
        }
        const icon = sampleButton.querySelector('svg');
        if (icon) {
          icon.outerHTML = svgIcon;
        }
      } else {
        sampleButton.style.cursor = 'not-allowed';
        sampleButton.style.backgroundColor = '#B9BABC';
        sampleButton.style.borderColor = '#B9BABC';
        sampleButton.style.color = "#FFFFFF";
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.textContent = 'Limit Reached';
      }
    } else {
      if (isIconButton) {
        sampleButton.removeAttribute('data-disabled');
        sampleButton.removeAttribute('data-added');
        sampleButton.removeAttribute('data-limit-reached');
        const buttonText = sampleButton.querySelector('.button-text');
        if (buttonText) {
          buttonText.textContent = 'Order Sample';
        }
        const icon = sampleButton.querySelector('svg');
        if (icon) {
          icon.outerHTML = svgIcon;
        }
      } else {
        sampleButton.style.cursor = 'pointer';
        sampleButton.style.backgroundColor = '#90BAEA';
        sampleButton.style.borderColor = '';
        sampleButton.style.color = 'white';
        sampleButton.removeAttribute('data-disabled');
        sampleButton.innerHTML = 'Order Sample';
      }
    }
  });
}

function addItem(id, quantity, options = {}) {
  // Get the current cart data from localStorage
  const cartData = JSON.parse(localStorage.getItem('cartData')) || { items: [] };
  const limitExempt = options.limitExempt === true;

  const maxSamples = getMaxSamples();
  const uniqueSamples = new Set(
    cartData.items
      .filter(item => countsTowardSampleLimit(item))
      .map(item => item.variant_id)
  );
  if (!limitExempt && uniqueSamples.size >= maxSamples) {
    document.querySelectorAll('.grid-icon-content').forEach(productElement => {
      const sampleButton = productElement.querySelector('.sample-button');
      if (!sampleButton) {
        return;
      }
      const isIconButton = sampleButton.hasAttribute('data-sample-icon');
      if (isIconButton) {
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.setAttribute('data-limit-reached', 'true');
        const buttonText = sampleButton.querySelector('.button-text');
        if (buttonText) {
          buttonText.textContent = 'Limit Reached';
        }
        const icon = sampleButton.querySelector('svg');
        if (icon) {
          icon.outerHTML = svgIcon;
        }
      } else {
        sampleButton.style.cursor = 'not-allowed';
        sampleButton.style.backgroundColor = '#B9BABC';
        sampleButton.style.borderColor = '#B9BABC';
        sampleButton.style.color = "#FFFFFF";
        sampleButton.setAttribute('data-disabled', 'true');
        sampleButton.textContent = 'Limit Reached';
      }
    });
    return;
  }

  // Create an items array with the item ID and quantity to be added
  let items = [{
    id: id,
    quantity: quantity,
    properties: limitExempt
      ? {
          _sample_limit_exempt: 'true',
          ...(options.sampleStyle ? { _sample_style: options.sampleStyle } : {}),
          ...(options.checkerboardGroup ? { _checkerboard_group: options.checkerboardGroup } : {})
        }
      : {
          ...(options.sampleStyle ? { _sample_style: options.sampleStyle } : {}),
          ...(options.checkerboardGroup ? { _checkerboard_group: options.checkerboardGroup } : {})
        }
  }];

  // Send a POST request to the Shopify API to add the item to the cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status && data.status === 'error') {
      console.error('Error adding item to cart:', data.message);
      return;
    }
    // Update the localStorage with the new cart data
    theme.cart.getCartData().then(cartData => {
      updateCartData(cartData);  // Update cart data and broadcast to other tabs
      refreshButtonStatus(cartData); // Refresh button status
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
    }).catch(error => {
      console.error('Error getting cart data:', error);
    });
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}

// Add a sample item with live cart validation (max + duplicates)
function addSampleItem(id, quantity, options = {}) {
  const maxSamples = getMaxSamples();
  const limitExempt = options.limitExempt === true;

  return theme.cart.getCartData().then((cartData) => {
    if (!cartData) return;

    const uniqueSamples = new Set();
    let alreadyInCart = false;
    (cartData.items || []).forEach((item) => {
      if (countsTowardSampleLimit(item)) {
        uniqueSamples.add(String(item.variant_id));
      }
      if (isSampleLineItem(item)) {
        if (String(item.variant_id) === String(id)) {
          alreadyInCart = true;
        }
      }
    });

    localStorage.setItem('cartData', JSON.stringify(cartData));
    refreshButtonStatus(cartData);

    if (alreadyInCart) {
      return;
    }

    if (!limitExempt && uniqueSamples.size >= maxSamples) {
      return;
    }

    return addItem(id, quantity, options);
  }).catch((error) => {
    console.error('Error validating sample limit:', error);
  });
}

// Wire up sample buttons within a given container (document or a dynamically injected panel)
function initSampleButtons(container) {
  container.querySelectorAll('.sample-button').forEach(button => {
    if (button._sampleInitialized) return;
    button._sampleInitialized = true;

    button.removeAttribute('onclick');

    button.addEventListener('touchstart', function(event) {
      handleMobileTap(this, event);
    });

    button.addEventListener('click', function(event) {
      event.preventDefault();

      const isTouchDevice = ('ontouchstart' in window);
      if (isTouchDevice) return;

      if (button.getAttribute('data-disabled') === 'true') return;

      const container = button.closest('.grid-icon-content');
      const sampleProductId = container.getAttribute('data-sample-product-id');
      if (sampleProductId) {
        addSampleItem(parseInt(sampleProductId, 10), 1, getSampleButtonOptions(button));
      }
    });
  });
}

// Initial setup to load and synchronize cart data on page load
document.addEventListener('DOMContentLoaded', function() {
  theme.cart.getCartData().then((cartData) => {
    if (!cartData) return;
    localStorage.setItem('cartData', JSON.stringify(cartData));
    refreshButtonStatus(cartData);
  }).catch((error) => {
    console.error("Error getting cart data:", error);
  });

  initSampleButtons(document);
});

// Function to remove item from cart
function removeItem(id) {
  // Create an updates object with the item ID set to 0 (removing the item)
  let updates = {};
  updates[id] = 0;
  
  // Send a POST request to the Shopify API to update the cart
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(data => {
    // Update the localStorage with the new cart data
    theme.cart.getCartData().then(cartData => {
      updateCartData(cartData);  // Update cart data and broadcast to other tabs
      // Dispatch a 'cart:build' event to rebuild the cart
      document.dispatchEvent(new CustomEvent('cart:build'));
      // Refresh the button status
      refreshButtonStatus(cartData);
    }).catch(error => {
      console.error('Error getting cart data:', error);
    });
  })
  .catch(error => {
    console.error('Error removing item from cart:', error);
  });
}
